import Cookies from "js-cookie";

export const getBrowserLang = function() {
  let browserLang = navigator.language ? navigator.language : navigator.browserLanguage;
  console.log('browserLang: ' + browserLang);
  if (browserLang.toLowerCase() === 'ja' || browserLang.toLowerCase() === 'ja-jp') {
    return 'ja';
  } else if(browserLang.toLowerCase() === 'ko' || browserLang.toLowerCase() === 'ko-kr') {
    return 'ko';
  } else if(browserLang.toLowerCase() === 'zh-tw' || browserLang.toLowerCase() === '"zh-tw"-tw') {
    return 'zh-tw';
  } else {
    return 'en';
  }
};

export const  getCountryLang = function() {
  return [
    {"countryCode":"us","countryName":"United States","langCode":"en","langName":"English"},
    {"countryCode":"jp","countryName":"日本","langCode":"ja","langName":"日本語"},
    {"countryCode":"us","countryName":"韩国","langCode":"ko","langName":"한국어"},
    {"countryCode":"tw","countryName":"台灣","langCode":"zh-tw","langName":"台灣正體"},
    ];
};

export const getArea = function() {
  let lang = Cookies.get('language') || getBrowserLang();
  let area = 'us';
  getCountryLang().forEach((row)=>{
    if(row.langCode===lang)
      area = row.countryCode;
  });
  return area;
};

export function notEmpty(value){
  return value !== 'undefined' && value !== undefined && value !== null && value !== '';
}

export function empty(value){
  return value === 'undefined' || value === undefined || value === null || value === '';
}

export const canReportFinger= function(fingerUser){
  let key = "finger_user_report";
  if(empty(fingerUser['openId']) || empty(fingerUser['fingerId'])){
    return false;
  }
  let oldFuStr = window.sessionStorage.getItem(key);
  if(oldFuStr){
    let oldFu = null;
    try{
      oldFu = JSON.parse(oldFuStr);
    }catch (e) {
      console.error("finger_user_report parse error");
    }
    if(oldFu){
      if(oldFu['fingerId']===fingerUser['fingerId'] && oldFu['openId']===fingerUser['openId']){
        return false;
      }
      if(oldFu['fingerId']===fingerUser['fingerId'] && empty(fingerUser['openId']) && notEmpty(oldFu['openId'])){
        return false;
      }
    }
  }
  // 设置新的sessionStorage
  window.sessionStorage.setItem(key, JSON.stringify(fingerUser));
  return true;
};
